import { useState } from "react";
import { Reveal } from "@components/ui";

/* ─── Data ─── */

const faqs = [
  {
    question: "Why does my bill include a billing fee?",
    answer: "This covers invoicing, system access, consumption analytics, and customer support.",
  },
  {
    question: "Why do I see VAT on my bill?",
    answer: "All utility services in UAE are subject to 5% VAT.",
  },
  {
    question: "Can I pay my bill after the due date?",
    answer: "Yes, but late payment fee of AED 35 applies.",
  },
  {
    question: "Can I divide the bill with my flat mate?",
    answer: "Only one registered customer can be billed per unit.",
  },
  {
    question: "How do I update my email or phone number?",
    answer: 'Login to portal → "Update Details".',
  },
  {
    question: "Why was my meter estimated this month?",
    answer: "Possible reasons: Inaccessible meter, Damaged meter, Technical failure.",
  },
  {
    question: "How do I get a receipt?",
    answer: "Receipts are automatically emailed after payment.",
  },
];

/* ─── Accordion Item ─── */

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-[#e0e1e6]">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 py-5 md:py-6 text-left"
      >
        <h3 className="text-[15px] md:text-[20px] lg:text-[28px] tracking-[-0.04em] font-medium text-[#1c1c1c] font-albert-sans leading-[1.3]">
          {question}
        </h3>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`shrink-0 text-[#62636c] transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        >
          <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          open ? "grid-rows-[1fr] opacity-100 pb-5 md:pb-6" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <p className="text-[13px] md:text-[18px] lg:text-[24px] tracking-[-0.04em] leading-[1.5] text-[rgba(10,14,46,0.65)] font-albert-sans">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
}

/* ─── Component ─── */

export function BillingFAQSection() {
  return (
    <section className="w-full bg-[#f6f6f9] py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 mb-10 md:mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/[0.08] text-[#122d63] text-[13px] font-semibold tracking-[-0.02em] uppercase">
              FAQ
            </span>
            <h2 className="text-center text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] leading-[1.1]">
              Billing FAQ
            </h2>
          </div>
        </Reveal>

        {/* FAQ list */}
        <Reveal direction="up">
          <div className="bg-white rounded-[16px] md:rounded-[24px] p-5 md:p-8 lg:p-10">
            {faqs.map((faq) => (
              <FAQItem key={faq.question} {...faq} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
